var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54 54",
    id: "shareit",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#329fff",
    d: "M34,10.45A7.46,7.46,0,1,1,26.56,3,7.46,7.46,0,0,1,34,10.45ZM42.89,31.3a7.46,7.46,0,1,0,7.45,7.45A7.45,7.45,0,0,0,42.89,31.3Zm-32.44,0a7.46,7.46,0,1,0,7.46,7.45A7.46,7.46,0,0,0,10.45,31.3Zm25-22a9.67,9.67,0,0,1,.08,1.2,8.87,8.87,0,0,1-.84,3.78,4.34,4.34,0,0,1-.37.71l-.11.19c.3.14,11,5.31,13.55,16.17A21,21,0,0,0,35.43,9.25Zm-25,20.51h.27A27.13,27.13,0,0,1,17.58,9.44s-13.27,4-12.52,22A9.24,9.24,0,0,1,10.45,29.76Zm25.61,15a6.3,6.3,0,0,1-1.33-2l-.11-.24c-.39.29-9.57,7-19.84,4.08a20.68,20.68,0,0,0,23.55,0l-.09-.05A9.35,9.35,0,0,1,36.06,44.71Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareitIcon);
export default __webpack_public_path__ + "static/media/shareit-icon.778f64db0e0345f756d802d6e1df5cd6.svg";
export { ForwardRef as ReactComponent };